import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import SelectDown from '@nerdwallet/react-icon/nerdwallet-ui/SelectDown';
import { ActionBlock } from '../ActionBlock/ActionBlock';
import styles from './DropdownTrigger.module.less';
/**
 * Provides the basic structure of the face of a `Select` component.
 *
 * This uses React.forwardRef because multiselect relies on being able to
 * attach a ref to the underlying DOM node.
 */

export var DropdownTrigger = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames, _classNames2;

  var block = _ref.block,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      fullWidth = _ref.fullWidth,
      mode = _ref.mode,
      otherProps = _objectWithoutProperties(_ref, ["block", "children", "className", "disabled", "error", "fullWidth", "mode"]);

  var containerClasses = classNames(styles.container, (_classNames = {}, _defineProperty(_classNames, styles.inline, !block), _defineProperty(_classNames, styles.block, block), _defineProperty(_classNames, styles.fullWidth, block || fullWidth), _classNames));
  var triggerClasses = classNames(className, styles.trigger, styles[mode], (_classNames2 = {}, _defineProperty(_classNames2, styles.disabled, disabled), _defineProperty(_classNames2, styles.fullWidth, block || fullWidth), _classNames2));
  var iconClasses = classNames(styles.icon, _defineProperty({}, styles['icon--disabled'], disabled));
  return /*#__PURE__*/React.createElement("div", {
    className: containerClasses,
    ref: ref
  }, /*#__PURE__*/React.createElement(ActionBlock, _extends({}, otherProps, {
    component: mode,
    className: triggerClasses,
    disabled: disabled,
    error: error
  }), children), /*#__PURE__*/React.createElement(SelectDown, {
    className: iconClasses
  }));
});

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  DropdownTrigger.propTypes = {
    block: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    fullWidth: PropTypes.bool,
    mode: PropTypes.oneOf(['select', 'button'])
  };
}

DropdownTrigger.defaultProps = {
  mode: 'select'
};
DropdownTrigger.displayName = 'DropdownTrigger';